import { FC } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/IconCircled/IconCircled.styl'
import themes from 'styles/base/themes.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import { Theme } from 'interfaces/component'
import { getSvgByFilename } from 'helpers/mediaHelpers'

type IconCircledProps = {
  iconSlug: string
  theme?: Theme
}

export const IconCircled: FC<IconCircledProps> = (props) => {
  const { children, iconSlug, theme = 'info' } = props

  const futureIconClasses = cn(styles.iconCircled, themes[theme as keyof typeof themes])

  return (
    <div className={ futureIconClasses }>
      <div className={ styles.content }>{ children }</div>
      <i className={ styles.svg } >
        <SvgIcon src={ getSvgByFilename(iconSlug) } />
      </i>
    </div>
  )
}

IconCircled.defaultProps = {
  theme: 'gray',
}
